import ArcGISPolygon from '@arcgis/core/geometry/Polygon'
import { Feature, Polygon, MultiPolygon } from 'geojson'

export class ArcgisGeometryHelper {
  static removeDuplicateCoordinates(coordinates: any[]) {
    const seen = new Set<string>()
    return coordinates.filter((item) => {
      const serializedItem = JSON.stringify(item)
      if (seen.has(serializedItem)) {
        return false
      } else {
        seen.add(serializedItem)
        return true
      }
    })
  }

  static geoJSONPolygonToArcGISPolygon(
    feature: Feature<Polygon | MultiPolygon>
  ) {
    const rNoDups = ArcgisGeometryHelper.removeDuplicateCoordinates(
      feature.geometry.coordinates
    ).flat()

    const geometry = new ArcGISPolygon({
      hasZ: false,
      hasM: false,
      rings: rNoDups,
      spatialReference: {
        wkid: 4326
      }
    })

    return geometry
  }
}
